/*
 *
 * CreateSafePasswordModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-2025
*/

import CreateSafePasswordModal from './CreateSafePasswordModalContainer'

export default CreateSafePasswordModal
